(function () {
  function initOMaxWhyChoose(section) {
    if (!section || section.dataset.sliderReady === 'true') return;

    const track = section.querySelector('[data-track]');
    const slides = Array.from(section.querySelectorAll('[data-slide]'));
    const prevBtn = section.querySelector('[data-prev]');
    const nextBtn = section.querySelector('[data-next]');
    const dotsWrap = section.querySelector('[data-dots]');

    if (!track || slides.length === 0) return;

    section.dataset.sliderReady = 'true';

    const mobileMq = window.matchMedia('(max-width: 767px)');
    let activeIndex = 0;
    let ticking = false;

    function isMobile() {
      return mobileMq.matches;
    }

    function getSlideLeft(index) {
      const slide = slides[index];
      if (!slide) return 0;

      return slide.offsetLeft - track.offsetLeft;
    }

    function buildDots() {
      if (!dotsWrap) return;

      dotsWrap.innerHTML = '';

      if (slides.length < 2) return;

      slides.forEach(function (_, index) {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'om-why__dot' + (index === activeIndex ? ' is-active' : '');
        dot.setAttribute('aria-label', 'اذهب إلى الميزة رقم ' + (index + 1));

        dot.addEventListener('click', function () {
          goTo(index);
        });

        dotsWrap.appendChild(dot);
      });
    }

    function updateDots() {
      if (!dotsWrap) return;

      const dots = dotsWrap.querySelectorAll('.om-why__dot');

      dots.forEach(function (dot, index) {
        dot.classList.toggle('is-active', index === activeIndex);
      });
    }

    function updateArrows() {
      if (!prevBtn || !nextBtn) return;

      const disabled = !isMobile() || slides.length < 2;

      prevBtn.disabled = disabled || activeIndex <= 0;
      nextBtn.disabled = disabled || activeIndex >= slides.length - 1;
    }

    function getNearestIndex() {
      const scrollLeft = track.scrollLeft;
      let nearestIndex = 0;
      let nearestDistance = Infinity;

      slides.forEach(function (slide, index) {
        const slideLeft = slide.offsetLeft - track.offsetLeft;
        const distance = Math.abs(slideLeft - scrollLeft);

        if (distance < nearestDistance) {
          nearestDistance = distance;
          nearestIndex = index;
        }
      });

      return nearestIndex;
    }

    function syncStateFromScroll() {
      if (!isMobile()) return;

      activeIndex = getNearestIndex();
      updateDots();
      updateArrows();
    }

    function goTo(index, behavior) {
      const safeIndex = Math.max(0, Math.min(index, slides.length - 1));
      const scrollBehavior = behavior || 'smooth';

      activeIndex = safeIndex;

      if (isMobile()) {
        track.scrollTo({
          left: getSlideLeft(safeIndex),
          behavior: scrollBehavior
        });
      }

      updateDots();
      updateArrows();
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        goTo(activeIndex - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        goTo(activeIndex + 1);
      });
    }

    track.addEventListener(
      'scroll',
      function () {
        if (!isMobile()) return;
        if (ticking) return;

        ticking = true;

        window.requestAnimationFrame(function () {
          syncStateFromScroll();
          ticking = false;
        });
      },
      { passive: true }
    );

    window.addEventListener('resize', function () {
      if (!isMobile()) {
        activeIndex = 0;
        track.scrollLeft = 0;
      } else {
        goTo(activeIndex, 'auto');
      }

      updateDots();
      updateArrows();
    });

    document.addEventListener('shopify:block:select', function (event) {
      if (!section.contains(event.target)) return;

      const blockSlide = event.target.closest('[data-slide]');
      const slideIndex = slides.indexOf(blockSlide);

      if (slideIndex > -1) {
        goTo(slideIndex, 'smooth');
      }
    });

    buildDots();
    updateDots();
    updateArrows();
  }

  function initAllOMaxWhyChoose(root) {
    const scope = root || document;
    const sections = scope.querySelectorAll('[data-o-max-why-choose]');

    sections.forEach(initOMaxWhyChoose);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAllOMaxWhyChoose(document);
    });
  } else {
    initAllOMaxWhyChoose(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAllOMaxWhyChoose(event.target);
  });
})();